import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BaseComponent } from '../base/base.component';
import * as d3 from 'd3';
import * as d3Time from 'd3-time';
import * as d3TimeFormat from 'd3-time-format';
import * as d3Scale from 'd3-scale';
import * as d3Axis from 'd3-axis';
import * as d3Selection from 'd3-selection';
import { ResizedEvent } from 'angular-resize-event';

@Component({
  selector: 'app-timeline-data',
  templateUrl: './timeline-data.component.html',
  styleUrls: ['./timeline-data.component.scss']
})
export class TimelineDataComponent extends BaseComponent implements OnInit {
  @Input() dataToDisplay: any = [];
  containerSize: any;
  xScale: any;
  xAxis: any;
  yScale: any;
  yAxis: any;
  svg: any = null;
  scaleFactor = 1;
  margin: { left: number; right: number; top: number; bottom: number; };
  start: any;
  end: any;
  width: any;
  height: any;
  @Input() timelineId: any;
  poseBlock: any = [];
  continuesBlock: any;
  timelinedata: any = [];
  itemHeight;
  itemMargin;
  myArray: any = []
  @Input() graphId: any;
  dateRange: any;
  gapBetweenRectangles: any = 20;
  nextDay: any;
  startTime: any;
  end_time: any;
  startDate: any;
  endDate: any;
  data: any;
  XAxis: any;
  poseSpecificValues: any;
  continueSpecificValues: any;
  bellSpecificValue: any;
  specifiedValue: any;
  day1: any;
  day7: any;
  riskTimer: any;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    public datepipe: DatePipe,
    private parentDilogRef: MatDialogRef<TimelineDataComponent>,) {
    super();
    this.margin = { left: 30, right: 30, top: 20, bottom: 30 };
    this.width = 400 - this.margin.left - this.margin.right;
    this.height = 200 - this.margin.top - this.margin.bottom;
  }
  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.poseBlock = this.dataToDisplay?.PoseBlock || []
    this.continuesBlock = this.dataToDisplay?.ContinueBlock || []

    this.poseBlock.sort((a, b) => new Date(a.start_time).getTime() - new Date(b.start_time).getTime());

    if (this.poseBlock.length > 0) {
      this.poseBlock[0].start_time = this.dataToDisplay.start_time;
    }
    this.poseBlock.forEach((obj) => {
      let endTimeTimestamp = new Date(obj.endtime).getTime();
      let respEndTimeStamp = new Date(this.dataToDisplay.end_time).getTime();
      if (endTimeTimestamp > respEndTimeStamp) {
        obj.endtime = this.dataToDisplay.end_time;
      }
    });

    this.continuesBlock.sort((a, b) => new Date(a.start_time).getTime() - new Date(b.start_time).getTime());

    if (this.continuesBlock.length > 0) {
      let respStartTime = new Date(this.dataToDisplay.start_time).getTime();
      let apiStartTime = new Date(this.continuesBlock[0].start_time).getTime();
      let apiMidRisk = new Date(this.continuesBlock[0].mid_risk_time).getTime();
      let apiHighRisk = new Date(this.continuesBlock[0].high_risk_time).getTime();

      if (apiStartTime < respStartTime) {
        this.continuesBlock[0].start_time = this.dataToDisplay.start_time;
      }
      if (apiMidRisk < respStartTime) {
        this.continuesBlock[0].mid_risk_time = this.dataToDisplay.start_time;
      }
      if (apiHighRisk < respStartTime) {
        this.continuesBlock[0].high_risk_time = this.dataToDisplay.start_time;
      }
    }
    this.continuesBlock.forEach((obj) => {
      let endTimeTimestamp = new Date(obj.endtime).getTime();
      let respEndTime = new Date(this.dataToDisplay.end_time).getTime();
      if (endTimeTimestamp > respEndTime) {
        obj.mid_risk_time = this.dataToDisplay.end_time;
        obj.high_risk_time = this.dataToDisplay.end_time;
        obj.endtime = this.dataToDisplay.end_time;
      }
    });
    if (this.dataToDisplay && Object.keys(this.dataToDisplay).length > 0) {
      this.svg = null;
      d3.selectAll('#timelineId').select("svg").remove();
      this.myArray = Object.keys(this.dataToDisplay).map(key => ({ [key]: [this.dataToDisplay[key]] }));
      if (this.dataToDisplay.days == 1) {
        this.drawSingleTimeline();
      } else {
        this.drawMultipleTimleine();
      }
    }
    this.day1 = this.dataToDisplay.days;
  }

  drawSingleTimeline(): void {
    this.drawTimelineSingle();
  }
  drawTimelineSingle(): void {
    let now = new Date(this.dataToDisplay.start_time);
    now.setHours(0, 0, 0, 0);
    this.start = now.getTime();

    // Set the end time to today 12 PM
    let today = new Date(this.dataToDisplay.end_time);
    today.setHours(23, 59, 0, 0);
    this.end = today.getTime();


    this.svg = this.singleAppendContainer();
    this.containerSize = (this.svg.node() as any).getBoundingClientRect();
    this.scaleFactor = (1 / (this.end - this.start)) * (this.containerSize.width - this.margin.left - this.margin.right);
    var graph = this.singleAppendGraph(this.svg)

    this.xScale = d3Scale
      .scaleTime()
      .domain([this.start, this.end])
      .range([this.margin.left, this.containerSize.width - this.margin.right])

    this.xAxis = d3Axis
      .axisBottom()
      .scale(this.xScale)
      .ticks(d3Time.timeMinute.every(30))
      .tickFormat(d3TimeFormat.timeFormat('%H:%M'))
      .tickSize(3)
      .tickPadding(5);

    this.yScale = d3Scale
      .scaleLinear()
      .domain([now, today])
      .range([this.margin.top, this.containerSize.height - this.margin.bottom]);

    this.yAxis = d3Axis.axisLeft().scale(this.yScale)

    this.svg
      .append('line') //horizontal
      .attr('x1', 15)
      .attr('y1', 45)
      .attr('x2', '96.8%')
      .attr('y2', 45)
      .style('stroke', 'gray')
      .style('stroke-width', 0.5);

    // Display yesterday's date on the left
    this.svg
      .append('text')
      .attr('x', 5)
      .attr('y', 50)
      .attr('dy', -25)
      .attr('text-anchor', 'start')
      .attr('transform', 'rotate(-90, ' + this.margin.left + ', ' + 45 + ')')
      .text(d3TimeFormat.timeFormat('%d-%m-%Y')(now))
      .style('font-size', 9);

    // Display today's date on the right
    this.svg
      .append('text')
      .attr('x', '99%')
      .attr('y', 50)
      .attr('dy', 0)
      .attr('text-anchor', 'end')
      .attr('transform', 'rotate(-90, ' + (this.containerSize.width - this.margin.right) + ', ' + 45 + ')')
      .text(d3TimeFormat.timeFormat('%d-%m-%Y')(today))
      .style('font-size', 9);

    // const timestamps = d3.timeMinute.range(this.start, this.end, 15);
    const verticalLines = d3.timeMinute.every(15).range(this.start, this.end);
    verticalLines.forEach((timestamp) => {
      if (timestamp >= this.start && timestamp <= this.end) {
        const xPosition = this.xScale(timestamp);

        this.svg
          .append('line') // Vertical lines
          .attr('x1', xPosition - 10)
          .attr('y1', this.margin.top)
          .attr('x2', xPosition - 10)
          .attr('y2', 70)
          .style('stroke', 'grey')
          .style('stroke-width', 0.5);
      }
    });


    this.svg.append('rect')
      .attr('x', 20)
      .attr('y', this.margin.top)
      .attr('width', this.containerSize.width - 60)
      .attr('height', 50)
      .style('fill', 'none')
      .style('stroke', 'lightgrey')
      .style('stroke-width', 1);

    this.svg.append('g')
      .attr("transform", 'translate(' + -10 + ',' + 70 + ')')
      .call(this.xAxis)
      .selectAll('text')
      .style('text-anchor', 'middle')
      .attr('dy', '-4px')
      .attr('transform', 'rotate(-90)')
      .attr('dx', -20)
      .attr('font-size', 9)
      .attr("font-family", "Verdana, Arial, Helvetica, sans-serif")
      .attr('stroke-width', 5)

    this.svg.selectAll('.tick text')
    // .style('text-anchor', 'middle')
    // .attr('dy', '-4px')
    // .attr('transform', 'rotate(-90)')
    // .attr('x', -20)
    // .attr('font-size', '9px')
    //this.singleBellIconImage();
    this.singleDrawPoseBlockGraph(graph);
    this.singleDrawContinueBlockGraph(graph);// Draw ContinueBlock bars at the bottom
  }
  singleAppendContainer(): any {
    if (!this.svg) {
      return d3
        .select('#timelineId')
        .append('svg')
        .attr('width', '100%')
        .attr('height', '103px')
        .style('margin-left', 17)
    } else {
      return this.svg;
    }
  }
  singleAppendGraph(svg): any {
    return svg
      .append('g')
      .attr('class', 'container')
      .attr('height', this.containerSize.height)
      .datum(this.myArray);
  }

  // singleBellIconImage(): void {
  //   if (this.dataToDisplay.alert_sent_times) {
  //     const bellIconPositions = this.dataToDisplay.alert_sent_times.map((alertTime) => {
  //       const date = new Date(alertTime);
  //       return this.xScale(date);
  //     });

  //     // Append bell icons
  //     bellIconPositions.forEach((xPosition) => {
  //       this.svg
  //         .append('image')
  //         .attr('xlink:href', 'data:image/png;base64,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')  // Replace with your bell icon path
  //         .attr('width', 10)
  //         .attr('height', 10)
  //         .attr('x', xPosition - 15)  // Adjust based on icon size
  //         .attr('y', 20);  // Adjust based on icon size and position above poseBlock
  //     });
  //   }
  // }
  singleDrawPoseBlockGraph(graph): void {
    this.itemHeight = 30;
    this.itemMargin = 29;
    var rectsView = graph.append('g').attr('class', 'view');
    var yAxisMapping = {};
    let maxStack = 1;
    graph.each((data) => {

      data.forEach((timelineItem, index) => {
        if (timelineItem.PoseBlock) {
          this.timelinedata = timelineItem.PoseBlock[0];
        }

        var timelines = this.timelinedata;

        timelines.forEach((arrayLoop) => {
          arrayLoop.start_time = new Date(arrayLoop.start_time).getTime();
          arrayLoop.endtime = new Date(arrayLoop.endtime).getTime();
          if (arrayLoop.start_time < this.start) {
            arrayLoop.start_time = this.start;
          }
          if (arrayLoop.endtime > this.end) {
            arrayLoop.endtime = this.end
          }
        })
        // Use the getColor function for PoseBlock color logic
        const getColorForPoseBlock = (d, i) => {
          if (d.posture && (d.posture === 'left')) return 'rgb(251,198,101)'
          else if (d.posture && (d.posture === 'right')) return 'rgb(255, 204, 220)'
          else if (d.posture && (d.posture === 'prone')) return 'rgb(196,164,220)'
          else if (d.posture && (d.posture === 'supine')) return 'rgb(19, 180, 255)'
          else if (d.posture && (d.posture === 'NPP')) return 'rgb(204,204,204)'
          else if (d.posture && (d.posture === 'No Data')) return 'rgb(247, 247, 205)'
          else { }
        };
        yAxisMapping[index] = maxStack;
        maxStack++;
        this.singleDrawTimeRect(rectsView, timelines, yAxisMapping, index, getColorForPoseBlock);
      });

    });
  }
  singleDrawContinueBlockGraph(graph): void {
    this.itemHeight = 12;
    this.itemMargin = 5;
    // Draw ContinueBlock bars at the bottom
    var rectsView = graph.append('g').attr('class', 'view');
    var yAxisMapping = {};
    let maxStack = 1;
    graph.each((data) => {
      data.forEach((timelineItem, index) => {
        if (timelineItem.ContinueBlock) {
          this.timelinedata = timelineItem?.ContinueBlock[0];
          var timelines = this.timelinedata;
          timelines.forEach((arrayLoop) => {
            arrayLoop.start_time = new Date(arrayLoop.start_time).getTime();
            arrayLoop.endtime = new Date(arrayLoop.endtime).getTime();
            if (arrayLoop.start_time < this.start) {
              arrayLoop.start_time = this.start;
            }
            if (arrayLoop.endtime > this.end) {
              arrayLoop.endtime = this.end
            }
            arrayLoop.mid_risk_time = new Date(arrayLoop.mid_risk_time).getTime();
            arrayLoop.high_risk_time = new Date(arrayLoop.high_risk_time).getTime();
            if (arrayLoop.mid_risk_time < this.start) {
              arrayLoop.mid_risk_time = this.start;
            }
            if (arrayLoop.mid_risk_time > this.end) {
              arrayLoop.mid_risk_time = this.end;
            }
            if (arrayLoop.high_risk_time < this.start) {
              arrayLoop.high_risk_time = this.start;
            }
            if (arrayLoop.high_risk_time > this.end) {
              arrayLoop.high_risk_time = this.end;
            }
          });
          let continueGraphBlock = [];
          timelines.forEach((item) => {
            let endtime: any;
            let time = item.start_time;
            if (item) {
              if (time < this.end) {
                if (item.mid_risk_time) { endtime = item.mid_risk_time }
                else { endtime = item.endtime }
                continueGraphBlock.push({ "start_time": item.start_time, "endtime": endtime, 'color': 'green' });

                if (item.mid_risk_time) {
                  if (item.high_risk_time) { endtime = item.high_risk_time }
                  else { endtime = item.endtime }
                  continueGraphBlock.push({ "start_time": item.mid_risk_time, "endtime": endtime, 'color': 'orange', "formatted_overall_risk_time": item.formatted_overall_risk_time, "high_risk_time": item.high_risk_time, "mid_risk_time": item.mid_risk_time });

                  if (item.high_risk_time) {
                    continueGraphBlock.push({ "start_time": item.high_risk_time, "endtime": item.endtime, 'color': 'red', "formatted_overall_risk_time": item.formatted_overall_risk_time, "high_risk_time": item.high_risk_time, "mid_risk_time": item.mid_risk_time });
                  }
                }
              }
            }
          })
          const getColorForcontinueBlock = (d, i) => {
            if (d.color && (d.color === 'green')) return 'rgb(152, 251, 152)';
            else if (d.color && (d.color === 'orange')) return 'orange'
            else if (d.color && (d.color === 'red')) return 'red';
            else { return 'blue' }
          };
          yAxisMapping[index] = maxStack;
          maxStack++;

          // Adjust styles or data as needed
          this.singleDrawTimeRect(rectsView, continueGraphBlock, yAxisMapping, index, getColorForcontinueBlock)
        }
      });
    });
  }
  singleDrawTimeRect(view, data, yMap, index, getColor): void {
    view
      .selectAll('svg')
      .data(data)
      .enter()
      .append(() => {
        return document.createElementNS(d3Selection.namespaces.svg, 'rect');
      })
      .attr('x', (d) => {
        return this.singleGetXPos(d);
      })
      .attr('y', () => {
        return this.singleGetStackPosition(yMap, index);
      })
      .attr('width', (d, i) => {
        return (d.endtime - d.start_time) * this.scaleFactor;
      })
      .attr('height', this.itemHeight)
      .style('fill', getColor)
      .on('click', (d, i) => {
        var selectedRect = d3Selection.select(this).node();
        var selectorLabel = 'text#' + selectedRect.id + '.textnumbers';
        var selectedLabel = d3Selection.select(selectorLabel).node();
      })
      .attr('class', (d, i) => {
        return 'timelineSeries_' + i;
      })
    view.selectAll("text.bar-text")
      .data(data)
      .enter()
      .append("text")
      .filter(d => (d.color === 'orange' && isNaN(d.high_risk_time)) || (d.color === 'red' && d.high_risk_time !== 'None' && d.formatted_overall_risk_time))
      .text(d => {
        let formattedTime = d.formatted_overall_risk_time;
        let [hours, minutes] = formattedTime.split(":").map(Number);
        if (hours === 0 && minutes < 60) {
          formattedTime = minutes;
        } else {
          formattedTime = formattedTime;
        }
        return formattedTime;
      })
      .attr('font-size', 9)
      .style('fill', 'white')
      .attr("x", d => this.singleRiskPost(d) - 1.5) // Adjust x position as needed
      .attr("y", d => 68) // Set a fixed value for y or adjust as needed
      .attr("class", "bar-text")
      .attr("font-family", "Verdana, Arial, Helvetica, sans-serif")
      .attr('stroke-width', 5)
  }

  singleGetXPos(d): number {
    return 20 + (d.start_time - this.start) * this.scaleFactor;
  }

  singleGetStackPosition(yMap, index): number {

    return (this.containerSize.height + this.itemMargin / 2 - this.margin.bottom - (this.itemHeight + this.itemMargin) * yMap[index]);
  }
  singleRiskPost(d): number {
    let compareTime = d.formatted_overall_risk_time
    let riskHoursDifference;
    let riskMinutesDifference;
    let [hours, minutes] = compareTime.split(":").map(Number);
    let midTime = new Date(d.mid_risk_time);
    let highTime = new Date(d.high_risk_time);
    const timeDifferenceMillis = highTime.getTime() - midTime.getTime();

    // Convert time difference to hours and minutes
    riskHoursDifference = Math.floor(timeDifferenceMillis / (1000 * 60 * 60));
    riskMinutesDifference = Math.floor((timeDifferenceMillis % (1000 * 60 * 60)) / (1000 * 60));

    // If the difference is less than 30 minutes, enter your logic
    if (riskHoursDifference > 0 && riskMinutesDifference < 30) {
      return 20 + ((d.start_time - this.start) * this.scaleFactor);
    } else if (hours === 0 && minutes < 30) {
      // If high_risk_time is less than 30 minutes, return the original position
      return 20 + ((d.start_time - this.start) * this.scaleFactor);
    } else {
      // If high_risk_time is 30 minutes or more, calculate the center position of the red bar
      const barWidth = (d.endtime - d.start_time) * this.scaleFactor;
      return 20 + ((d.start_time - this.start) * this.scaleFactor) + barWidth / 2;
    }
  }

  drawMultipleTimleine(): void {
    this.drawTimelines();
  }
  drawTimelines(): void {
    this.myArray.forEach((block) => {
      var simple = block['PoseBlock'];
      if (simple) {
        let splitAgain = true;

        // While there are additional splits to be made
        while (splitAgain) {
          splitAgain = false;
          simple[0].forEach((item) => {
            this.nextDay = new Date(item.start_time)
            this.nextDay.setDate(this.nextDay.getDate() + 1, 0, 0, 0);
            this.nextDay.setHours(0, 0, 0, 0);
            newTimestamp = this.nextDay.getTime() - 1
            this.nextDay.setTime(newTimestamp);

            if (new Date(item.endtime) > this.nextDay) {
              //additional block to 
              let additionalBlock = {
                start_time: {},
                endtime: {},
                duration: {},
                patient_number: {},
                posture: {}
              };
              var actualEndTime = item.endtime;
              const formattedEndTime = `${this.nextDay.getFullYear()}-${(this.nextDay.getMonth() + 1).toString().padStart(2, '0')}-${this.nextDay.getDate().toString().padStart(2, '0')} ${this.nextDay.getHours().toString().padStart(2, '0')}:${this.nextDay.getMinutes().toString().padStart(2, '0')}`;
              item.endtime = formattedEndTime;
              let newDay: any = new Date(item.start_time);
              var difference = this.nextDay - newDay;
              var resultInMinutes = Math.round(difference / 60000);
              item.duration = resultInMinutes + "";
              newTimestamp = this.nextDay.getTime() + 1
              this.nextDay.setTime(newTimestamp);
              additionalBlock.patient_number = item.patient_number;
              additionalBlock.start_time = `${this.nextDay.getFullYear()}-${(this.nextDay.getMonth() + 1).toString().padStart(2, '0')}-${this.nextDay.getDate().toString().padStart(2, '0')} ${this.nextDay.getHours().toString().padStart(2, '0')}:${this.nextDay.getMinutes().toString().padStart(2, '0')}`;
              additionalBlock.endtime = actualEndTime;
              additionalBlock.posture = item.posture;
              let endDaty: any = new Date(item.endtime)
              difference = endDaty - this.nextDay;
              resultInMinutes = Math.round(difference / 60000);
              additionalBlock.duration = resultInMinutes + "";
              simple[0].push(additionalBlock);
              this.data = simple;
              splitAgain = true;
            }
          });
        }
      }
    });
    this.myArray.forEach((block) => {
      var continueBlock = block['ContinueBlock'];
      if (continueBlock) {
        let splitAgain = true;

        // While there are additional splits to be made
        while (splitAgain) {
          splitAgain = false;
          continueBlock[0].forEach((item) => {
            this.nextDay = new Date(item.start_time);
            this.nextDay.setHours(23, 59, 59, 999);

            if (new Date(item.mid_risk_time) > this.nextDay) {
              //additional block to 
              var additionalBlock1 = {
                start_time: '',
                endtime: '',
                duration: '',
                high_mid_diff_duration: '',
                high_risk_time: '',
                is_active: null,
                last_updated: '',
                formatted_overall_risk_time: '',
                mid_risk_time: '',
                patient_number: '',
                posture: '',
                risk_status: '',
              };
              const formatDateTime = (date) => {
                return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date
                  .getDate()
                  .toString()
                  .padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date
                  .getMinutes()
                  .toString()
                  .padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
              };
              var actualMidRiskTime = item.mid_risk_time;
              item.mid_risk_time = formatDateTime(this.nextDay);
      
              if (new Date(item.high_risk_time) > this.nextDay) {
                var actualHighRiskTime = item.high_risk_time;
                item.high_risk_time = formatDateTime(this.nextDay);
              }
      
              if (new Date(item.endtime) > this.nextDay) {
                var actualendTime = item.endtime;
                item.endtime = formatDateTime(this.nextDay);
              }
      
              let newDay:any = new Date(item.start_time);
              var difference = this.nextDay - newDay;
              var resultInMinutes = Math.round(difference / 60000);
              item.duration = resultInMinutes.toString();
      
              this.nextDay.setTime(this.nextDay.getTime() + 1); // Move to start of the next day
              additionalBlock1.patient_number = item.patient_number;
              additionalBlock1.start_time = formatDateTime(this.nextDay);
              additionalBlock1.endtime = actualendTime;
              additionalBlock1.posture = item.posture;
              additionalBlock1.risk_status = item.risk_status;
              additionalBlock1.formatted_overall_risk_time = item.formatted_overall_risk_time;
              additionalBlock1.is_active = item.is_active;
              additionalBlock1.high_risk_time = actualHighRiskTime;
              additionalBlock1.mid_risk_time = formatDateTime(new Date(actualMidRiskTime));
              additionalBlock1.high_mid_diff_duration = item.high_mid_diff_duration;
      
              let endDaty:any = new Date(actualendTime);
              difference = endDaty - this.nextDay;
              resultInMinutes = Math.round(difference / 60000);
              additionalBlock1.duration = resultInMinutes.toString();
      
              // Add the new block for the next day
              continueBlock[0].push(additionalBlock1);
              this.data = continueBlock;
              splitAgain = true;
            } else if (new Date(item.high_risk_time) > this.nextDay) { 
              // Create an additional block
              var additionalBlock2 = {
                start_time: '',
                endtime: '',
                duration: '',
                high_mid_diff_duration: '',
                high_risk_time: '',
                is_active: null,
                last_updated: '',
                formatted_overall_risk_time: '',
                mid_risk_time: '',
                patient_number: '',
                posture: '',
                risk_status: '',
              };
            
              // Save the original high_risk_time
              var actualHighRiskTime = item.high_risk_time;
            
              // Format high_risk_time for the current day (up to 23:59:59)
              const formattedHighRiskTime = `${this.nextDay.getFullYear()}-${(this.nextDay.getMonth() + 1)
                .toString()
                .padStart(2, '0')}-${this.nextDay.getDate().toString().padStart(2, '0')} 23:59:59`;
              item.high_risk_time = formattedHighRiskTime;
            
              // Handle endtime if it also crosses into the next day
              if (new Date(item.endtime) > this.nextDay) {
                var actualEndTime = item.endtime;
                const formattedEndTime = `${this.nextDay.getFullYear()}-${(this.nextDay.getMonth() + 1)
                  .toString()
                  .padStart(2, '0')}-${this.nextDay.getDate().toString().padStart(2, '0')} 23:59:59`;
                item.endtime = formattedEndTime;
              }
            
              // Calculate duration for the current day
              let newDay: any = new Date(item.start_time);
              var difference = this.nextDay - newDay;
              var resultInMinutes = Math.round(difference / 60000);
              item.duration = resultInMinutes.toString();
            
              // Move to the start of the next day
              this.nextDay.setTime(this.nextDay.getTime() + 1);
            
              // Prepare additional block for the next day
              additionalBlock2.patient_number = item.patient_number;
              additionalBlock2.start_time = `${this.nextDay.getFullYear()}-${(this.nextDay.getMonth() + 1)
                .toString()
                .padStart(2, '0')}-${this.nextDay.getDate().toString().padStart(2, '0')} 00:00:00`;
              additionalBlock2.endtime = actualEndTime;
              additionalBlock2.posture = item.posture;
              additionalBlock2.risk_status = item.risk_status;
              additionalBlock2.formatted_overall_risk_time = item.formatted_overall_risk_time;
              additionalBlock2.is_active = item.is_active;
              additionalBlock2.high_risk_time = actualHighRiskTime;// Set the next day's high_risk_time
              additionalBlock2.mid_risk_time = additionalBlock2.start_time; // Handle mid_risk_time similarly if needed
              additionalBlock2.high_mid_diff_duration = item.high_mid_diff_duration;
              let endDay: any = new Date(actualEndTime);        // Calculate duration for the next day
              difference = endDay - this.nextDay;
              resultInMinutes = Math.round(difference / 60000);
              additionalBlock2.duration = resultInMinutes.toString();
              continueBlock[0].push(additionalBlock2);
              this.data = continueBlock; // Update the data and continue splitting
              splitAgain = true;
            } else if (new Date(item.endtime) > this.nextDay) { 
              // Create an additional block
              var additionalBlock3 = {
                start_time: '',
                endtime: '',
                duration: '',
                high_mid_diff_duration: '',
                high_risk_time: '',
                is_active: null,
                last_updated: '',
                formatted_overall_risk_time: '',
                mid_risk_time: '',
                patient_number: '',
                posture: '',
                risk_status: '',
              };
            
              // Save the original endtime
              var actualEndTime = item.endtime;
            
              // Format endtime for the current day (up to 23:59:59)
              const formattedEndTime = `${this.nextDay.getFullYear()}-${(this.nextDay.getMonth() + 1)
                .toString()
                .padStart(2, '0')}-${this.nextDay.getDate().toString().padStart(2, '0')} 23:59:59`;
              item.endtime = formattedEndTime;
            
              // Calculate duration for the current day
              let startDate: any = new Date(item.start_time);
              var difference = this.nextDay - startDate;
              var resultInMinutes = Math.round(difference / 60000);
              item.duration = resultInMinutes.toString();
            
              // Move to the start of the next day
              this.nextDay.setTime(this.nextDay.getTime() + 1);
            
              // Prepare the additional block for the next day
              additionalBlock3.patient_number = item.patient_number;
              additionalBlock3.start_time = `${this.nextDay.getFullYear()}-${(this.nextDay.getMonth() + 1)
                .toString()
                .padStart(2, '0')}-${this.nextDay.getDate().toString().padStart(2, '0')} 00:00:00`;
              additionalBlock3.endtime = actualEndTime;
              additionalBlock3.posture = item.posture;
              additionalBlock3.risk_status = item.risk_status;
              additionalBlock3.formatted_overall_risk_time = item.formatted_overall_risk_time;
              additionalBlock3.is_active = item.is_active;
              if(item.high_risk_time === 'None') {
                additionalBlock3.high_risk_time = item.high_risk_time;
                additionalBlock3.mid_risk_time = item.mid_risk_time;
              }else {
                // Update high_risk_time and mid_risk_time for the next day block
                additionalBlock3.high_risk_time = additionalBlock3.start_time; // Starting at the new day
                additionalBlock3.mid_risk_time = additionalBlock3.start_time; // Starting at the new day
              }
            
              // Retain high_mid_diff_duration and calculate duration for the next day
              additionalBlock3.high_mid_diff_duration = item.high_mid_diff_duration;
              let nextDayEnd: any = new Date(actualEndTime);
              difference = nextDayEnd - this.nextDay;
              resultInMinutes = Math.round(difference / 60000);
              additionalBlock3.duration = resultInMinutes.toString();
            
              // Add the additional block to the continueBlock array
              continueBlock[0].push(additionalBlock3);
            
              // Update the data and flag to split again
              this.data = continueBlock;
              splitAgain = true;
            }
          });
        }
      }
    });

    this.startTime = new Date(this.dataToDisplay.start_time);
    this.end_time = new Date(this.dataToDisplay.end_time);

    let emptyData = new Date(this.dataToDisplay.start_time);

    // Set hours for start and end times
    this.startTime.setHours(0, 0, 0, 0);
    this.end_time.setHours(23, 59, 0, 0);

    this.start = new Date(this.end_time);
    this.start.setHours(0, 0, 0, 0);
    this.start = this.start.getTime();

    this.end = new Date(this.end_time);
    this.end.setHours(23, 59, 0, 0);
    this.end = this.end.getTime();

    this.startDate = new Date(this.startTime);
    this.endDate = new Date(this.end_time);
    this.endDate.setDate(this.endDate.getDate());
    var newTimestamp = this.startDate.getTime() + (24 * 60 * 60 * 1000 - 1);
    this.endDate.setTime(newTimestamp);

    var splitData = new Array(this.dataToDisplay.days);
    var startDates = new Array(this.dataToDisplay.days);
    var endDates = new Array(this.dataToDisplay.days);

    for (let i = this.dataToDisplay.days - 1; i >= 0; i--) {
      startDates[i] = new Date(this.startDate);
      endDates[i] = new Date(this.endDate);
      this.startDate.setDate(this.startDate.getDate() + 1);
      this.endDate.setDate(this.endDate.getDate() + 1);
    }

    // Split the data to 7 arrays
    if (this.data && this.data[0]) {
      splitData = startDates.map((startDate, index) => {
        const endDate = endDates[index];
        return this.data.filter(d => {
          const startTimeUTC = new Date(d.start_time);
          const endTimeUTC = new Date(d.endtime);
          return startTimeUTC >= startDate && endTimeUTC <= endDate;
        });
      });
    }

    // Generate an array of formatted dates for the y-axis scale
    this.dateRange = Array.from({ length: this.dataToDisplay.days }, (_, i) => new Date(startDates[i]));

    this.dateRange.reverse();

    this.svg = this.appendContainer();
    this.containerSize = (this.svg.node() as any).getBoundingClientRect();
    this.scaleFactor = (1 / (this.end - this.start)) * (this.containerSize.width - this.margin.left - this.margin.right);
    var graph = this.appendGraph(this.svg)

    this.xScale = d3Scale
      .scaleTime()
      .domain([this.start, this.end])
      .range([this.margin.left, this.containerSize.width - this.margin.right])

    this.xAxis = d3Axis
      .axisBottom()
      .scale(this.xScale)
      .ticks(d3Time.timeMinute.every(30))
      .tickFormat(d3TimeFormat.timeFormat('%H:%M'))
      .tickSize(3)
      .tickPadding(5);

    if (this.dataToDisplay.days == 1) {
      this.bellSpecificValue = [20]
    } else if (this.dataToDisplay.days == 2) {
      this.bellSpecificValue = [20, 90]
    } else if (this.dataToDisplay.days == 3) {
      this.bellSpecificValue = [20, 90, 160];
    } else if (this.dataToDisplay.days == 4) {
      this.bellSpecificValue = [20, 90, 160, 230]
    } else if (this.dataToDisplay.days == 5) {
      this.bellSpecificValue = [20, 90, 160, 230, 300];
    } else if (this.dataToDisplay.days == 6) {
      this.bellSpecificValue = [20, 90, 160, 230, 300, 370];
    } else if (this.dataToDisplay.days == 7) {
      this.bellSpecificValue = [20, 90, 160, 230, 300, 370, 440];
    }

    this.yScale = d3Scale
      .scaleLinear()
      .domain([0, this.dateRange.length - 1])
      .range([Math.min(...this.bellSpecificValue), Math.max(...this.bellSpecificValue)]);


    this.yAxis = d3Axis.axisLeft().scale(this.yScale);

    this.svg.selectAll('.day-group')
      .data(this.dateRange)
      .enter()
      .append('g')
      .attr('class', 'day-group')
      .attr('transform', (date, i) => `translate(${this.margin.left}, ${this.margin.top + i * (50 + this.gapBetweenRectangles)})`)
      .each((date, i, nodes) => {
        const group = d3.select(nodes[i]);

        // Add rectangle
        group.append('rect')
          .attr('width', '94.1%')
          .attr('height', 50)
          .attr('x', 10)
          .style('fill', 'none')
          .style('stroke', 'grey')
          .style('stroke-width', 0.5);

        // Add horizontal line in the middle
        group.append('line')
          .attr('x1', 1)
          .attr('y1', 25)
          .attr('x2', 960)
          .attr('y2', 25)
          .style('stroke', 'grey')
          .style('stroke-width', 0.5);

        // Add vertical lines
        const timestamps = d3.timeMinute.every(30).range(this.start, this.end);

        group.selectAll('.vertical-line')
          .data(timestamps)
          .enter()
          .append('line')
          .attr('class', 'vertical-line')
          .attr('x1', timestamp => this.xScale(timestamp))
          .attr('y1', 0)
          .attr('x2', timestamp => this.xScale(timestamp))
          .attr('y2', 50)
          .style('stroke', 'grey')
          .style('stroke-width', 0.5);

        group.append('text')
          .attr('x', -5)
          .attr('y', -10)
          .attr('dy', '0')
          .attr('text-anchor', 'end')
          .attr('transform', `rotate(-90)`)
          .text(d3TimeFormat.timeFormat('%Y-%m-%d')(date))
          .style('font-size', 9);
      });
    if (this.dataToDisplay.days == 2) {
      this.XAxis = 140;
    } else if (this.dataToDisplay.days == 3) {
      this.XAxis = 211;
    } else if (this.dataToDisplay.days == 4) {
      this.XAxis = 281
    } else if (this.dataToDisplay.days == 5) {
      this.XAxis = 351;
    } else if (this.dataToDisplay.days == 6) {
      this.XAxis = 420;
    } else if (this.dataToDisplay.days == 7) {
      this.XAxis = 491;
    }
    this.svg.append('g')
      .attr('transform', `translate(${11}, ${this.XAxis})`)
      .attr('class', 'x-axis')
      .call(this.xAxis)
      .selectAll('text')
      .style('text-anchor', 'middle')
      .attr('dy', '-4px')
      .attr('transform', 'rotate(-90)')
      .attr('dx', -20)
      .attr('font-size', 9)
      .attr("font-family", "Verdana, Arial, Helvetica, sans-serif")
      .attr('stroke-width', 5)

    //this.bellIconImage();
    this.drawPoseBlockGraph(graph);
    this.drawContinueBlockGraph(graph);
  }
  appendContainer(): void {
    if (!this.svg) {
      return d3
        .select('#timelineId')
        .append('svg')
        .attr('width', '100%')
        .attr('height', '94.7vh')
    } else {
      return this.svg;
    }
  }
  appendGraph(svg): void {
    return svg
      .append('g')
      .attr('class', 'container')
      .attr('height', this.containerSize.height)
      .datum(this.myArray);
  }
  // bellIconImage() {
  //   if (this.dataToDisplay.alert_sent_times) {
  //     const bellIconPositions = this.dataToDisplay.alert_sent_times.map((alertTime) => {
  //       const date = new Date(alertTime);
  //       const xPosition = this.getXPositionForDate(date);
  //       const yPosition = this.getYPositionForDate(date);
  //       return { x: xPosition, y: yPosition };
  //     });

  //     // Append bell icons
  //     bellIconPositions.forEach(({ x, y }) => {
  //       this.svg
  //         .append('image')
  //         .attr('xlink:href', 'data:image/png;base64,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')
  //         .attr('width', 10)
  //         .attr('height', 10)
  //         .attr('x', x - 18)
  //         .attr('y', y);
  //     });
  //   }
  // }

  getXPositionForDate(date) {
    var startdate = date;
    var bellrange;
    for (let i = 0; i < this.dateRange.length; i++) {
      bellrange = this.dateRange[i];

      if (
        startdate.getFullYear() === bellrange.getFullYear() &&
        startdate.getMonth() === bellrange.getMonth() &&
        startdate.getDate() === bellrange.getDate()
      ) {
        return 55 + (startdate.getTime() - bellrange.getTime()) * this.scaleFactor;
      }
    }
  }
  getYPositionForDate(date) {
    var time = new Date(date).toLocaleDateString();
    var index = this.dateRange.findIndex(date => new Date(date).toLocaleDateString() === time);
    return this.yScale(index);
  }

  drawPoseBlockGraph(graph) {
    this.itemHeight = 30;
    this.itemMargin = 29;
    var rectsView = graph.append('g').attr('class', 'view');
    var yAxisMapping = {};
    let maxStack = 1;
    graph.each((data) => {
      data.forEach((timelineItem, index) => {
        const sample = timelineItem['PoseBlock']
        if (sample) {
          let timelines = sample;

          timelines[0].forEach((item) => {
            item.duration = item.duration;
            item.start_time = new Date(item.start_time).getTime();
            item.endtime = new Date(item.endtime).getTime();
            item.patient_number = item.patient_number;
            item.posture = item.posture;

            if (this.isDateInRange(item.start_time)) {
              // Assuming getColorForPoseBlock should be called once per object
              const getColorForPoseBlock = (d, i) => {
                if (d.posture && (d.posture === 'left')) return 'rgb(251,198,101)';
                else if (d.posture && (d.posture === 'right')) return 'rgb(255, 204, 220)';
                else if (d.posture && (d.posture === 'prone')) return 'rgb(196,164,220)';
                else if (d.posture && (d.posture === 'supine')) return 'rgb(19, 180, 255)';
                else if (d.posture && (d.posture === 'NPP')) return 'rgb(204,204,204)';
                else if (d.posture && (d.posture === 'No Data')) return 'rgb(255, 255, 224)';
                else { }
              };

              yAxisMapping[index] = maxStack;
              maxStack++;
              if (this.dataToDisplay.days == 1) {
                this.poseSpecificValues = [30]
              } else if (this.dataToDisplay.days == 2) {
                this.poseSpecificValues = [30, 100]
              } else if (this.dataToDisplay.days == 3) {
                this.poseSpecificValues = [30, 100, 170];
              } else if (this.dataToDisplay.days == 4) {
                this.poseSpecificValues = [30, 100, 170, 240]
              } else if (this.dataToDisplay.days == 5) {
                this.poseSpecificValues = [30, 100, 170, 240, 310];
              } else if (this.dataToDisplay.days == 6) {
                this.poseSpecificValues = [30, 100, 170, 240, 310, 380];
              } else if (this.dataToDisplay.days == 7) {
                this.poseSpecificValues = [30, 100, 170, 240, 310, 450];
              }
              // Draw the bar graph for the current date and timeline
              this.drawTimeRect(rectsView, [item], getColorForPoseBlock, this.poseSpecificValues);
            }
          });

        }

      });
    });
  }
  drawContinueBlockGraph(graph) {
    this.itemHeight = 10;
    this.itemMargin = 10;
    var rectsView = graph.append('g').attr('class', 'view');
    var yAxisMapping = {};
    let maxStack = 1;
    graph.each((data) => {
      data.forEach((timelineItem, index) => {
        const timelines = timelineItem['ContinueBlock']
        if (timelines) {

          timelines[0].forEach((item) => {
            item.start_time = new Date(item.start_time).getTime();
            item.endtime = new Date(item.endtime).getTime();
            item.mid_risk_time = new Date(item.mid_risk_time).getTime();
            item.high_risk_time = new Date(item.high_risk_time).getTime();

            let continueGraphBlock = [];
            let endtime: any;
            let time = item.start_time;
            if (item) {
              if (time < this.end) {
                if (item.mid_risk_time) { endtime = item.mid_risk_time }
                else { endtime = item.endtime }
                continueGraphBlock.push({ "start_time": item.start_time, "endtime": endtime, 'color': 'green', "formatted_overall_risk_time": ' ', });

                if (item.high_risk_time) { endtime = item.high_risk_time }
                else { endtime = item.endtime }
                continueGraphBlock.push({ "start_time": item.mid_risk_time, "endtime": endtime, 'color': 'orange', "formatted_overall_risk_time": item.formatted_overall_risk_time, "high_risk_time": item.high_risk_time, "mid_risk_time": item.mid_risk_time });

                if (item.high_risk_time) {
                  continueGraphBlock.push({ "start_time": item.high_risk_time, "endtime": item.endtime, 'color': 'red', "formatted_overall_risk_time": item.formatted_overall_risk_time, "high_risk_time": item.high_risk_time, "mid_risk_time": item.mid_risk_time });
                }
              }
            }

            if (this.isDateInRange(item.start_time)) {
              const getColorForcontinueBlock = (d, i) => {
                if (d.color && (d.color === 'green')) return 'rgb(152, 251, 152)';
                else if (d.color && (d.color === 'orange')) return 'orange'
                else if (d.color && (d.color === 'red')) return 'red';
                else { return 'black' }
              };

              yAxisMapping[index] = maxStack;
              maxStack++;
              if (this.dataToDisplay.days == 1) {
                this.continueSpecificValues = [60]
              } else if (this.dataToDisplay.days == 2) {
                this.continueSpecificValues = [60, 130]
              } else if (this.dataToDisplay.days == 3) {
                this.continueSpecificValues = [60, 130, 200];
              } else if (this.dataToDisplay.days == 4) {
                this.continueSpecificValues = [60, 130, 200, 270]
              } else if (this.dataToDisplay.days == 5) {
                this.continueSpecificValues = [60, 130, 200, 270, 340];
              } else if (this.dataToDisplay.days == 6) {
                this.continueSpecificValues = [60, 130, 200, 270, 340, 410];
              } else if (this.dataToDisplay.days == 7) {
                this.continueSpecificValues = [60, 130, 200, 270, 340, 410, 480];
              }

              this.drawTimeRect(rectsView, continueGraphBlock, getColorForcontinueBlock, this.continueSpecificValues);
            }
          });
        }
      });
    });
  }
  isDateInRange(date) {
    return this.dateRange.some(rangeDate => date >= rangeDate.getTime() && date < rangeDate.getTime() + 24 * 60 * 60 * 1000);
  }
  drawTimeRect(view, data, getColor, specificValues) {
    view.selectAll('svg')
      .data(data)
      .enter()
      .append(() => {
        return document.createElementNS(d3.namespaces.svg, 'rect');
      })
      .attr('x', (d) => {
        return this.getXPos(d);
      })
      .attr('y', (d) => {
        return this.getStackPosition(d, specificValues);
      })

      .attr('width', (d, i) => {
        return (d.endtime - d.start_time) * this.scaleFactor;
      })

      .attr('height', this.itemHeight)
      .style('fill', getColor)
      .on('click', (d, i) => {
        var selectedRect = d3Selection.select(this).node();
        var selectorLabel = 'text#' + selectedRect.id + '.textnumbers';
        var selectedLabel = d3Selection.select(selectorLabel).node();
      })
      .attr('class', (d, i) => {
        return 'timelineSeries_' + i;
      })
      .filter(d => (d.color === 'orange' && isNaN(d.high_risk_time)) || (d.color === 'red' && d.high_risk_time !== 'None' && d.formatted_overall_risk_time))
      .each(d => {
        if (this.dataToDisplay.days == 1) {
          this.specifiedValue = [67]
        } else if (this.dataToDisplay.days == 2) {
          this.specifiedValue = [67, 137]
        } else if (this.dataToDisplay.days == 3) {
          this.specifiedValue = [67, 137, 207];
        } else if (this.dataToDisplay.days == 4) {
          this.specifiedValue = [67, 137, 207, 277]
        } else if (this.dataToDisplay.days == 5) {
          this.specifiedValue = [67, 137, 207, 277, 347];
        } else if (this.dataToDisplay.days == 6) {
          this.specifiedValue = [67, 137, 207, 277, 347, 417];
        } else if (this.dataToDisplay.days == 7) {
          this.specifiedValue = [67, 137, 207, 277, 347, 417, 487];
        }
        let textY = this.textPosition(d, this.specifiedValue) + this.itemHeight / 2 - 5;
        let formattedTime = d.formatted_overall_risk_time;
        let [hours, minutes] = formattedTime.split(":").map(Number);
        if (hours === 0 && minutes < 60) {
          formattedTime = minutes;
        } else {
          formattedTime = formattedTime;
        }
        view
          .append('text')
          .text(formattedTime)
          .attr('font-size', 8)
          .attr('fill', 'white')
          .attr("font-family", "Verdana, Arial, Helvetica, sans-serif")
          .attr('x', this.getRiskPost(d))
          .attr('y', textY)
          .attr('class', 'bar-text')
          .attr('stroke-width', 5);
      });
  }
  textPosition(d, specifiedValue) {
    const startTimestamp = new Date(d.start_time).toLocaleDateString();
    const dateIndex = this.dateRange.findIndex(date => new Date(date).toLocaleDateString() === startTimestamp);
    return d3
      .scaleLinear()
      .domain([0, this.dateRange.length - 1])
      .range([Math.min(...specifiedValue), Math.max(...specifiedValue)])(dateIndex);
  }
  getXPos(d) {
    const startDate = new Date(d.start_time);
    let dayRange;

    for (let i = 0; i < this.dateRange.length; i++) {
      dayRange = this.dateRange[i];

      if (
        startDate.getFullYear() === dayRange.getFullYear() &&
        startDate.getMonth() === dayRange.getMonth() &&
        startDate.getDate() === dayRange.getDate()
      ) {
        // Return the desired calculation when matched
        return 40 + (startDate.getTime() - dayRange.getTime()) * this.scaleFactor;
      }
    }
  }
  getStackPosition(d, specificValues) {
    const startTimestamp = new Date(d.start_time).toLocaleDateString();
    const dateIndex = this.dateRange.findIndex(date => new Date(date).toLocaleDateString() === startTimestamp);
    return d3
      .scaleLinear()
      .domain([0, this.dateRange.length - 1])
      .range([Math.min(...specificValues), Math.max(...specificValues)])(dateIndex);
  }
  getRiskPost(d) {
    let startDate = new Date(d.start_time);
    let matchDate = new Date(this.dataToDisplay.end_time).getTime()
    let dayRange;
    let riskHoursDifference;
    let riskMinutesDifference;
    let compareTime = d.formatted_overall_risk_time
    let [hours, minutes] = compareTime.split(":").map(Number);
    let midTime = new Date(d.mid_risk_time);
    let highTime = new Date(d.high_risk_time);
    const timeDifferenceMillis = highTime.getTime() - midTime.getTime();
    let endDate = new Date(d.endtime).getTime();

    if (endDate === matchDate && d.color === 'red') {
      return null;  // Return null if it's still in low-risk (green) period
    }

    // Convert time difference to hours and minutes
    riskHoursDifference = Math.floor(timeDifferenceMillis / (1000 * 60 * 60));
    riskMinutesDifference = Math.floor((timeDifferenceMillis % (1000 * 60 * 60)) / (1000 * 60));

    for (let i = 0; i < this.dateRange.length; i++) {
      dayRange = this.dateRange[i];

      if (
        startDate.getFullYear() === dayRange.getFullYear() &&
        startDate.getMonth() === dayRange.getMonth() &&
        startDate.getDate() === dayRange.getDate()
      ) {
        // Return the desired calculation when matched
        if (riskHoursDifference > 0 && riskMinutesDifference < 30) {
          return 40 + ((startDate.getTime() - dayRange.getTime()) * this.scaleFactor);
        } else if (hours === 0 && minutes < 30) {
          // If high_risk_time is less than 30 minutes, return the original position
          return 40 + ((startDate.getTime() - dayRange.getTime()) * this.scaleFactor);
        } else {
          // If high_risk_time is 30 minutes or more, calculate the center position of the red bar
          const barWidth = (d.endtime - d.start_time) * this.scaleFactor;
          return 30 + ((startDate.getTime() - dayRange.getTime()) * this.scaleFactor) + barWidth / 2;
        }
      }
    }
  }
}

